import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import GeneralConfigurationActions, { generalConfigurationActionTypes } from '../../actions/configurations/generalConfigurationActions';
import GeneralConfigurationServices from '../../services/configurations/generalConfigurationServices';

/**
 * @param action
 */
function* _updateGeneralConfiguration(action) {
  try {
    yield put(GeneralConfigurationActions.updateGeneralConfigurationLoading(true));
    const generalConfiguration = yield GeneralConfigurationServices.updateGeneralConfiguration(action.payload);
    if (generalConfiguration.success) {
      notification.open({
        type: 'success',
        message: 'General Configuration successfully updated',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
      yield put(GeneralConfigurationActions.updateGeneralConfigurationLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: generalConfiguration?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(GeneralConfigurationActions.updateGeneralConfigurationLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(GeneralConfigurationActions.updateGeneralConfigurationLoading(false));
  }
}

/**
 *
 */
function* updateGeneralConfiguration() {
  yield takeLatest(generalConfigurationActionTypes.UPDATE_GENERAL_CONFIGURATION.REQUEST, _updateGeneralConfiguration);
}

/**
 * @param action
 */
function* _getGeneralConfiguration(action) {
  const {
    entityType, callback,
  } = action;
  try {
    GeneralConfigurationActions.getGeneralConfigurationSuccess(null);
    yield put(GeneralConfigurationActions.getGeneralConfigurationLoading(true, entityType));
    const generalConfiguration = yield GeneralConfigurationServices.getGeneralConfiguration(entityType);
    yield put(GeneralConfigurationActions.getGeneralConfigurationSuccess(generalConfiguration?.data, entityType));
    if (callback) action.callback();
    yield put(GeneralConfigurationActions.getGeneralConfigurationLoading(false, entityType));
  } catch (error) {
    yield put(GeneralConfigurationActions.getGeneralConfigurationLoading(false, entityType));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* getGeneralConfiguration() {
  yield takeLatest(generalConfigurationActionTypes.GET_GENERAL_CONFIGURATION.REQUEST, _getGeneralConfiguration);
}

export default function* generalConfigurationSaga() {
  yield all([
    getGeneralConfiguration(), updateGeneralConfiguration(),
  ]);
}
